import * as React from "react";
import styled from "styled-components";

import withModal from "../../hocs/withModal";
import { useModal } from "../../hooks";

import { PageTitle, Description } from "../../typo";
import Button from "../../elements/Button";

const Base = styled.div`
  padding: 32px;
  display: flex;
  flex-direction: column;
  align-items: center;
  user-select: none;
`;

type Props = {
  title: string;
  message: React.ReactNode;
  cancelLabel: string;
  okLabel: string;
  type: "mutate" | "delete";
  onConfirm: () => void;
};

function Confirm({
  title,
  message,
  type,
  cancelLabel,
  okLabel,
  onConfirm
}: Props) {
  const { hideModal } = useModal();

  return (
    <Base>
      <PageTitle
        style={{ marginBottom: 20, width: "100%", textAlign: "center" }}
      >
        {title}
      </PageTitle>
      <Description
        style={{ marginBottom: 32, width: "100%", textAlign: "center" }}
      >
        {message}
      </Description>
      <div style={{ display: "flex" }}>
        <Button type="grey" text={cancelLabel} onClick={hideModal} />
        <Button
          style={{ marginLeft: 24 }}
          type="color"
          c={[type === "delete" ? "error" : "primary", 5]}
          text={okLabel}
          onClick={() => {
            onConfirm();
            hideModal();
          }}
        />
      </div>
    </Base>
  );
}

export default withModal(
  {
    width: 500
  },
  Confirm
);
